import { render, staticRenderFns } from "./InvoiceDetailItem.vue?vue&type=template&id=70950548&"
import script from "./InvoiceDetailItem.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports